var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:[_vm.shouldAnimate],attrs:{"fab":"","small":"","raised":"","text":""},on:{"click":function($event){return _vm.toggleLang()}}},[_c('v-icon',[_vm._v("mdi-translate")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }